import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const redirectLoggedInToPrompts = (route: ActivatedRouteSnapshot) => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);

    // Check the authentication status
    return authenticationService.isLoggedIn().pipe(
        take(1),
        map((loggedIn) => {
            if (loggedIn) {
                return router.createUrlTree([route.params.tenant, 'prompts']);
            } else {
                return true;
            }
        }),
    );
};
